import { Province } from 'src/app/models/locality.model';
import { PersonType } from './../../../../models/person-type.model';
import { UtilsService } from 'src/app/services/utils.service';
import { DocumentsService } from './../../../../services/documents.service';
import { SelectOption } from './../../../../models/select-option.model';
import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { Document } from 'src/app/models/document.model';

@Component({
    selector: 'app-representative-form',
    templateUrl: './representative-form.component.html',
    styleUrls: ['./representative-form.component.scss']
})
export class RepresentativeFormComponent implements OnInit {

    disabledPersonType = false;

    formGroupValue: UntypedFormGroup;
    @Input()
    set formGroup(value: UntypedFormGroup) {
        this.formGroupValue = value;
        if (value) {
            this.updateValidators(this.selectedPosition);
            this.formGroup.controls.cargo.valueChanges.subscribe(newValue => {
                this.updateValidators(newValue);
                this.formGroup.controls.nombreCargo.setValue(null);
                this.formGroup.controls.nroAsambleaEstatuto.setValue(null);
                this.formGroup.controls.fechaPoder.setValue(null);
                this.formGroup.controls.poderAdjunto.setValue(null);
            });
        }
    }
    get formGroup() {
        return this.formGroupValue;
    }

    personTypeValue: PersonType;
    @Input()
    set personType(value: PersonType) {
        this.personTypeValue = value;
        if (value === 'FISICA') {
            this.positions = [
                { codigo: 'APODERADO', descripcion: 'Apoderado' },
                { codigo: 'USUFRUCTUARIO_OTROS', descripcion: 'Usufructuario/Otro' }
            ];
            if (this.disabledPersonType) {
                this.formGroup?.controls?.tieneRepresentante?.enable();
                this.disabledPersonType = false;
            }
        } else {
            this.positions = [
                { codigo: 'APODERADO', descripcion: 'Apoderado' },
                { codigo: 'USUFRUCTUARIO_OTROS', descripcion: 'Usufructuario/Otro' },
            ];
            this.formGroup?.controls?.tieneRepresentante?.setValue(true);
            this.formGroup?.controls?.tieneRepresentante?.disable();
            this.disabledPersonType = true;
        }
    }
    get personType() {
        return this.personTypeValue;
    }

    @Input()
    provinces?: Province[];

    positions: SelectOption[] = [
        { codigo: 'APODERADO', descripcion: 'Apoderado' },
        { codigo: 'USUFRUCTUARIO_OTROS', descripcion: 'Usufructuario/Otro' },
    ];

    get selectedPosition() {
        return this.formGroup?.controls?.cargo?.value as 'APODERADO' | 'USUFRUCTUARIO_OTROS' | null;
    }

    constructor(
        private documentsService: DocumentsService,
        private utilsService: UtilsService
    ) { }

    ngOnInit(): void {
        this.updateValidators(this.selectedPosition);
        this.formGroup.controls.cargo.valueChanges.subscribe(newValue => {
            this.updateValidators(newValue);
            this.formGroup.controls.nombreCargo.reset();
            this.formGroup.controls.nroAsambleaEstatuto.reset();
            this.formGroup.controls.fechaPoder.reset();
            this.formGroup.controls.poderAdjunto.reset();
        });
    }

    updateValidators(cargo: string) {
        if (cargo === 'USUFRUCTUARIO_OTROS') {
            this.formGroup.controls.nombreCargo.setValidators([Validators.required]);
            this.formGroup.controls.nroAsambleaEstatuto.setValidators([Validators.required]);
        } else {
            this.formGroup.controls.nombreCargo.setValidators([]);
            this.formGroup.controls.nroAsambleaEstatuto.setValidators([]);
        }
    }

    uploadPower(event?: Document) {
        if (event?.archivo) {
            this.documentsService.uploadDocumentAWS(event?.archivo, 'PODER_REPRESENTANTE', undefined, undefined, true).then(document => {
                this.formGroup.controls.poderAdjunto.setValue(document);
            }).catch(_ => {
                this.utilsService.alert('Error al subir archivo ' + event?.nombreArchivo, '');
                this.formGroup.controls.poderAdjunto.setValue(undefined);
            });
        }
    }
}
